

















import {Component, Prop, Vue} from "nuxt-property-decorator";

@Component({
  components: {
    PageBreadcrumbs: () => import("~/components/page/PageBreadcrumbs.vue"),
  },
})
export default class SPage extends Vue {
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  breadcrumbs?: any[];

  @Prop({type: String, required: false}) title?: string;

  @Prop({type: Boolean, default: true}) container?: boolean;

  @Prop({type: String, required: false}) subtitle?: string;
}
